export const shouldTrimFieldValue = (type, trimWhitespace = false) => trimWhitespace &&
    type !== 'number' &&
    type !== 'date' &&
    type !== 'datetime-local' &&
    type !== 'time' &&
    type !== 'password';
export const collapseConsecutiveSpaces = (value) => value.replace(/ {2,}/g, ' ');
export const normalizeTrimmedValue = (value, multiline, phase) => {
    if (multiline) {
        return phase === 'blur' ? value.trim() : value.replace(/^\s+/, '');
    }
    const withoutLeading = value.replace(/^\s+/, '');
    const collapsed = collapseConsecutiveSpaces(withoutLeading);
    return phase === 'blur' ? collapsed.trim() : collapsed;
};
export const normalizeAutocompleteInputValue = (value) => normalizeTrimmedValue(value, false, 'change');
export const wrapAutocompleteInputProps = (inputProps, trimWhitespace) => {
    if (!trimWhitespace || !inputProps) {
        return inputProps;
    }
    const { onChange, onBlur, ...rest } = inputProps;
    return {
        ...rest,
        onChange: (event) => {
            const normalized = normalizeAutocompleteInputValue(event.target.value);
            if (normalized !== event.target.value) {
                event.target.value = normalized;
            }
            onChange?.(event);
        },
        onBlur: (event) => {
            const normalized = normalizeTrimmedValue(event.target.value, false, 'blur');
            if (normalized !== event.target.value) {
                event.target.value = normalized;
            }
            onBlur?.(event);
        }
    };
};
